import {QuotesQuoteCountryChoices} from 'generated/graphql';
import * as settings from 'settings';

export const convertBrlToUsd = (
    brlAmount: number,
    exchangeRate?: number | null,
): number | null => {
    if (!exchangeRate) return null;
    return Number((brlAmount / exchangeRate).toFixed(Number(settings.MAX_DECIMALS)));
};

export const getQuoteExchangeRate = (
    country: QuotesQuoteCountryChoices | string,
    quoteExchangeRate?: number | null,
    settingsExchangeRate?: number | null,
): number | null => {
    if (country !== QuotesQuoteCountryChoices.Others) return null;
    return quoteExchangeRate ?? settingsExchangeRate ?? null;
};

export const isOthersCountryQuote = (
    country: QuotesQuoteCountryChoices | string,
): boolean => country === QuotesQuoteCountryChoices.Others;
